var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import styles from '../../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import '../year-page-view/year-page-view.lit';
import '../year-page-navigation/year-page-navigation.lit';
import { sdsCustomElement } from '../../../utilities/custom-components';
/**
 * Control represents a year picker
 */
let SdsInnerYearPicker = (() => {
    var _SdsInnerYearPicker_yearPageView_accessor_storage, _SdsInnerYearPicker_yearPageNavigation_accessor_storage, _SdsInnerYearPicker_currentYear_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-inner-year-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _yearPageView_decorators;
    let _yearPageView_initializers = [];
    let _yearPageView_extraInitializers = [];
    let _yearPageNavigation_decorators;
    let _yearPageNavigation_initializers = [];
    let _yearPageNavigation_extraInitializers = [];
    let _currentYear_decorators;
    let _currentYear_initializers = [];
    let _currentYear_extraInitializers = [];
    var SdsInnerYearPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInnerYearPicker_yearPageView_accessor_storage.set(this, __runInitializers(this, _yearPageView_initializers, void 0));
            _SdsInnerYearPicker_yearPageNavigation_accessor_storage.set(this, (__runInitializers(this, _yearPageView_extraInitializers), __runInitializers(this, _yearPageNavigation_initializers, void 0)));
            this.sdsYearPageView = __runInitializers(this, _yearPageNavigation_extraInitializers);
            _SdsInnerYearPicker_currentYear_accessor_storage.set(this, __runInitializers(this, _currentYear_initializers, void 0));
            this.itemSelectHandler = (__runInitializers(this, _currentYear_extraInitializers), (event) => {
                this.updateSelectedYear(event.detail.year);
            });
            this.itemHoverHandler = (event) => {
                this.dispatchEvent(new CustomEvent(SdsInnerYearPicker.INNER_YEAR_PICKER_HOVER_EVENT, {
                    detail: {
                        hoveredYear: event.detail.hoveredYear,
                    },
                }));
            };
            this.changePage = (event) => {
                this.yearPageView.goByPage(event.detail.step);
            };
            this.pageChangedHandler = (event) => {
                this.yearPageNavigation.startYear = event.detail.firstYearInPage;
                this.yearPageNavigation.endYear = event.detail.lastYearInPage;
            };
        }
        get yearPageView() { return __classPrivateFieldGet(this, _SdsInnerYearPicker_yearPageView_accessor_storage, "f"); }
        set yearPageView(value) { __classPrivateFieldSet(this, _SdsInnerYearPicker_yearPageView_accessor_storage, value, "f"); }
        get yearPageNavigation() { return __classPrivateFieldGet(this, _SdsInnerYearPicker_yearPageNavigation_accessor_storage, "f"); }
        set yearPageNavigation(value) { __classPrivateFieldSet(this, _SdsInnerYearPicker_yearPageNavigation_accessor_storage, value, "f"); }
        get currentYear() { return __classPrivateFieldGet(this, _SdsInnerYearPicker_currentYear_accessor_storage, "f"); }
        set currentYear(value) { __classPrivateFieldSet(this, _SdsInnerYearPicker_currentYear_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-date-picker">
                <sds-year-page-navigation
                    @sds.year-page-navigation.page-changed="${this.changePage}"
                >
                </sds-year-page-navigation>
                <sds-year-page-view
                    current-year="${this.currentYear}"
                    @sds.year-page-view.select="${this.itemSelectHandler}"
                    @sds.year-page-view.hovered="${this.itemHoverHandler}"
                    @sds.year-page-view.page-changed="${this.pageChangedHandler}"
                >
                </sds-year-page-view>
            </div>
        `;
        }
        /**
         * state of the year, this value is delegated to sds-year-page-view
         */
        setYearStateMapper(stateMapper) {
            var _a;
            (_a = this.sdsYearPageView) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(stateMapper);
        }
        openPageFor(year) {
            var _a;
            (_a = this.sdsYearPageView) === null || _a === void 0 ? void 0 : _a.openPageFor(year);
        }
        openPageInitialPage() {
            var _a;
            (_a = this.sdsYearPageView) === null || _a === void 0 ? void 0 : _a.openPageInitialPage();
        }
        async firstUpdated() {
            await this.updateComplete;
            this.initContentContainer();
        }
        initContentContainer() {
            var _a;
            const sdsYearPageView = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-year-page-view');
            if (sdsYearPageView) {
                this.sdsYearPageView = sdsYearPageView;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        updateValue(selectedYear) {
            this.dispatchEvent(new CustomEvent(SdsInnerYearPicker.INNER_YEAR_PICKER_CHANGE_EVENT, {
                detail: { selectedYear },
            }));
        }
        updateSelectedYear(value) {
            this.updateValue(value);
        }
    };
    _SdsInnerYearPicker_yearPageView_accessor_storage = new WeakMap();
    _SdsInnerYearPicker_yearPageNavigation_accessor_storage = new WeakMap();
    _SdsInnerYearPicker_currentYear_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInnerYearPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _yearPageView_decorators = [query('sds-year-page-view')];
        _yearPageNavigation_decorators = [query('sds-year-page-navigation')];
        _currentYear_decorators = [property({ reflect: true, attribute: 'current-year', type: Number })];
        __esDecorate(_classThis, null, _yearPageView_decorators, { kind: "accessor", name: "yearPageView", static: false, private: false, access: { has: obj => "yearPageView" in obj, get: obj => obj.yearPageView, set: (obj, value) => { obj.yearPageView = value; } }, metadata: _metadata }, _yearPageView_initializers, _yearPageView_extraInitializers);
        __esDecorate(_classThis, null, _yearPageNavigation_decorators, { kind: "accessor", name: "yearPageNavigation", static: false, private: false, access: { has: obj => "yearPageNavigation" in obj, get: obj => obj.yearPageNavigation, set: (obj, value) => { obj.yearPageNavigation = value; } }, metadata: _metadata }, _yearPageNavigation_initializers, _yearPageNavigation_extraInitializers);
        __esDecorate(_classThis, null, _currentYear_decorators, { kind: "accessor", name: "currentYear", static: false, private: false, access: { has: obj => "currentYear" in obj, get: obj => obj.currentYear, set: (obj, value) => { obj.currentYear = value; } }, metadata: _metadata }, _currentYear_initializers, _currentYear_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInnerYearPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.INNER_YEAR_PICKER_CHANGE_EVENT = 'sds.inner-year-picker.changed';
    _classThis.INNER_YEAR_PICKER_HOVER_EVENT = 'sds.inner-year-picker.hovered';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInnerYearPicker = _classThis;
})();
export { SdsInnerYearPicker };
